import React from 'react';
import { Selectors, State } from '@grandvisionhq/auth';
import { Button } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var LaunchEyeExamContainer = function () {
    var getLabel = useIntl().getLabel;
    var auth = useSelector(Selectors.getAuth);
    var isAuthLoading = State.getLoggedInState(auth) === 'loading';
    var formattedRoutes = useSelector(Selectors.getFormattedRoutes);
    var loginRoute = formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.login;
    var buttonProps = React.useMemo(function () {
        if (State.isLoggedIn(auth)) {
            return {
                href: 'Todo: easee link',
                caption: getLabel('To be done in MACC-8936'),
            };
        }
        return {
            href: typeof window !== 'undefined'
                ? loginRoute + "?returnPath=" + window.location.pathname
                : loginRoute,
            caption: getLabel('elements.easeeCta.loginAction'),
            isLoading: isAuthLoading,
        };
    }, [auth, getLabel, isAuthLoading, loginRoute]);
    return (
    // todo: add the consent checkbox here (or move all this to a view component)
    React.createElement(Button, __assign({}, buttonProps)));
};

export { LaunchEyeExamContainer as LaunchEyeExam };
//# sourceMappingURL=index.js.map
